<template>
  <v-tour
    :name="name"
    :steps="steps"
    :callbacks="tourCallbacks"
    :options="tourOptions"
  >
    <template slot-scope="tour">
      <transition name="fade">
        <v-step
          v-if="tour.steps[tour.currentStep]"
          :key="tour.currentStep"
          :step="tour.steps[tour.currentStep]"
          :previous-step="tour.previousStep"
          :next-step="tour.nextStep"
          :stop="tour.stop"
          :skip="tour.skip"
          :is-first="tour.isFirst"
          :is-last="tour.isLast"
          :labels="tour.labels"
          :highlight="tour.highlight"
        >
          <template>
            <div
              class="absolute top-20 left-20 w-40 h-40 z-50"
              style="box-shadow:0 0 0 99999px rgba(58,24,209,0.25)"
            >
              Hello
            </div>

            <div
              slot="header"
              class="z-40"
            >
              <div
                class="
                                        text-xl mt-2 leading-tight
                                    "
              >
                {{ tour.steps[tour.currentStep].header.title }}
              </div>
              <button
                @click="tour.skip"
                class="rounded-full border border-pink-200 bg-pink-100 w-4 h-4 absolute right-2 top-2 flex justify-center items-center"
              >
                <icon
                  name="close"
                  class="text-pink-600 h-1.5 w-1.5"
                />
              </button>
            </div>
            <div
              slot="content"
              class="text-gray-600 text-xs font-light my-4"
            >
              {{ tour.steps[tour.currentStep].content }}
            </div>
            <div
              slot="actions"
              class="z-40"
            >
              <div class="flex justify-center space-x-3">
                <action-button
                  v-if="tour.isFirst"
                  border-color="border-indigo-300"
                  text-color="text-indigo-600"
                  bg-color="bg-indigo-100"
                  libelle="Ignorer"
                  text-size="text-sm"
                  :is-small="true"
                  @clickAction="tour.skip"
                />
                <action-button
                  v-if="!tour.isFirst"
                  border-color="border-indigo-300"
                  text-color="text-indigo-600"
                  bg-color="bg-indigo-100"
                  libelle="Précédent"
                  text-size="text-sm"
                  :is-small="true"
                  @clickAction="tour.previousStep"
                />
                <action-button
                  v-if="!tour.isLast"
                  border-color="border-transparent"
                  text-color="text-white"
                  bg-color="bg-indigo-600"
                  libelle="Suivant"
                  icon="arrow-right_1"
                  text-size="text-sm"
                  :is-small="true"
                  :right="true"
                  :onboarding="true"
                  @clickAction="tour.nextStep"
                />
                <action-button
                  v-if="tour.isLast"
                  border-color="border-transparent"
                  text-color="text-white"
                  bg-color="bg-indigo-600"
                  libelle="Fermer"
                  text-size="text-sm"
                  :is-small="true"
                  :right="true"
                  @clickAction="tour.finish"
                />
              </div>
              <div 
                v-if="tour.isLast" 
                class="flex flex-row justify-center items-center mt-3"
              >
                <input
                  type="checkbox"
                  id="stop_showing_tour"
                  class="mr-2"
                >
                <label class="text-2sm font-light">Ne plus afficher</label>
              </div>
            </div>
          </template>
        </v-step>
      </transition>
    </template>
  </v-tour>
</template>

<script>
import ActionButton from './../ActionButton.vue';
import Icon from './../Icon.vue';

export default {
  components:{
    ActionButton,
    Icon,
  },

  props:{
    name:{
      type: String,
    },
    steps:{
      type:Array,
    },
  },

  data(){
    return {
      tourOptions: {
        useKeyboardNavigation: false,
        highlight: true
      },
      tourCallbacks:{
        onStart: this.tourStarted,
        onFinish: this.tourFinished,
        onSkip: this.tourSkipped,
      },
    };
  },

  methods:{
    tourStarted(){
      if (this.name === 'tourNeopassForm' && this.$can(((((this.$route.path.split('/form/neopass/') || [])[1] || '').split('/') || [])[2] || '')+'_edit')){
        let saveButton = document.querySelector('#tour_save_datas');
        let tempSaveButton = document.querySelector('#tempSaveBtn');
        tempSaveButton.classList.toggle('hidden');
        saveButton.parentElement.classList.toggle('z-10');
        saveButton.parentElement.classList.toggle('sticky');
      }
    },

    tourFinished(){
      if (this.name === 'tourNeopassForm' && this.$can(((((this.$route.path.split('/form/neopass/') || [])[1] || '').split('/') || [])[2] || '')+'_edit')){
        let saveButton = document.querySelector('#tour_save_datas');
        let tempSaveButton = document.querySelector('#tempSaveBtn');
        tempSaveButton.classList.toggle('hidden');
        saveButton.parentElement.classList.toggle('z-10');
        saveButton.parentElement.classList.toggle('sticky');
      }
      this.$emit('tourFinished');
    },

    tourSkipped(){
      if (this.name === 'tourNeopassForm' && this.$can(((((this.$route.path.split('/form/neopass/') || [])[1] || '').split('/') || [])[2] || '')+'_edit')){
        let saveButton = document.querySelector('#tour_save_datas');
        let tempSaveButton = document.querySelector('#tempSaveBtn');
        tempSaveButton.classList.toggle('hidden');
        saveButton.parentElement.classList.toggle('z-10');
        saveButton.parentElement.classList.toggle('sticky');
      }
      this.$emit('tourSkipped');
    },
  }
};
</script>
